import React from 'react';
import { SectionWrapper } from './SectionWrapper';
const painPoints = [{
  emoji: '😰',
  title: 'Sin protocolo claro ante crisis en menores',
  desc: 'Riesgo suicida en adolescentes, agitación, primer episodio psicótico: zona gris sin sistema.'
}, {
  emoji: '📋',
  title: 'Documentás sin saber si te protege',
  desc: 'Sin plantillas legales adaptadas a menores que te blinden desde el primer minuto.'
}, {
  emoji: '⚖️',
  title: 'El consentimiento en menores te genera dudas',
  desc: '¿Quién firma? ¿Qué pasa cuando los padres no se ponen de acuerdo? ¿Cuándo decide el menor?'
}, {
  emoji: '📚',
  title: 'Nada práctico para tu realidad clínica',
  desc: 'Los libros no contemplan la complejidad legal de trabajar con pacientes menores de edad en Argentina.'
}, {
  emoji: '💊',
  title: 'Prescribir en menores te genera inseguridad',
  desc: 'Sin referencia rápida de psicofármacos en niños y adolescentes con aval legal y clínico.'
}, {
  emoji: '🧠',
  title: 'Detectás señales de abuso pero no sabés qué hacer',
  desc: 'Sin protocolo claro de denuncia obligatoria que te proteja y no destruya el vínculo terapéutico.'
}, {
  emoji: '🚨',
  title: 'El juzgado de familia te pide informes',
  desc: 'Sin plantillas profesionales adaptadas al sistema judicial argentino de menores.'
}, {
  emoji: '🩺',
  title: 'Escuela, familia y juzgado te llaman al mismo tiempo',
  desc: 'Nadie te enseñó a coordinar la red institucional sin perder el norte clínico ni la cobertura legal.'
}];
export function PainPoints() {
  return <div className="bg-[#0a1f44] text-white" data-id="element-142">
      <SectionWrapper data-id="element-143">
        <div className="text-center mb-8 md:mb-12" data-id="element-144">
          <p className="text-amber-400 font-bold tracking-wider text-[10px] md:text-xs uppercase mb-2 md:mb-3" data-id="element-145">
            REALIDAD DE LA PRÁCTICA INFANTOJUVENIL
          </p>
          <h2 className="text-[22px] md:text-3xl font-extrabold mb-3 md:mb-4 tracking-tight" data-id="element-146">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-blue-200 max-w-2xl mx-auto text-[14px] md:text-base text-balance" data-id="element-147">
            Si trabajás con niños y adolescentes en Argentina, esto te suena
            familiar:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6" data-id="element-148">
          {painPoints.map((pt, i) => <div key={i} className="bg-blue-900/30 border border-blue-800/60 rounded-2xl p-4 md:p-6 hover:bg-blue-800/40 transition-colors shadow-sm" data-id="element-149">
              <div className="text-2xl md:text-3xl mb-3 md:mb-4 bg-blue-950/50 w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center" data-id="element-150">
                {pt.emoji}
              </div>
              <h3 className="font-bold text-[15px] md:text-lg mb-2 leading-tight text-blue-50" data-id="element-151">
                {pt.title}
              </h3>
              <p className="text-blue-200/80 text-[13px] md:text-sm leading-relaxed" data-id="element-152">
                {pt.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-10 md:mt-16 text-center bg-blue-900/20 py-6 px-4 rounded-2xl border border-blue-800/30" data-id="element-153">
          <p className="text-[16px] md:text-2xl font-semibold text-amber-400 max-w-3xl mx-auto text-balance" data-id="element-154">
            ¿Cuántas consultas más sin un sistema que respalde cada decisión y
            te blinde legalmente?
          </p>
        </div>
      </SectionWrapper>
    </div>;
}